var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [_c("span", { staticClass: "header-item" }, [_vm._v("Device Data")])]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-content", staticStyle: { height: "480px" } },
      [
        _c(
          "el-row",
          { attrs: { gutter: 20 } },
          [
            _c("el-col", { attrs: { span: 4 } }, [
              _c(
                "div",
                { staticClass: "device-image" },
                [_c("DeviceImage", { attrs: { device: _vm.device } })],
                1
              ),
            ]),
            _vm._v(" "),
            _c("el-col", { attrs: { span: 20 } }, [
              _c("div", { staticClass: "device-row" }, [
                _c("div", { staticClass: "device-row-label" }, [
                  _vm._v("\n            ID\n          "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "device-row-value" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("capitalize")(_vm.device.doorbot_id)) +
                      "\n          "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "device-row" }, [
                _c("div", { staticClass: "device-row-label" }, [
                  _vm._v("\n            Type\n          "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "device-row-value" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("capitalize")(_vm.device.type)) +
                      "\n          "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "device-row" }, [
                _c("div", { staticClass: "device-row-label" }, [
                  _vm._v("\n            Name\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "device-row-value" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "Device",
                            params: {
                              customer_id: _vm.customerId,
                              doorbot_id: _vm.device.doorbot_id,
                            },
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("capitalize")(_vm.device.name)) +
                            "\n            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "device-row" }, [
                _c("div", { staticClass: "device-row-label" }, [
                  _vm._v("\n            Mac Address\n          "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "device-row-value" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.device.mac_address) +
                      "\n          "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "device-row" }, [
                _c("div", { staticClass: "device-row-label" }, [
                  _vm._v("\n            Power Source\n          "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "device-row-value" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.powerSourceFormatted(_vm.device.power_source)
                      ) +
                      "\n          "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "device-row" }, [
                _c("div", { staticClass: "device-row-label" }, [
                  _vm._v("\n            Location\n          "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "device-row-value" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.device.location_id) +
                      "\n          "
                  ),
                ]),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }